module.exports = __webpack_public_path__ + "static/media/classicos_feminino_fitness.b90a0235.jpg";